import { VenueLoyaltySettingsPublic } from '@lunit/shared-types';
import { api } from './client';
import { coreRuntime } from '@core/runtime';

/**
 * Get public loyalty settings for the venue (referral & welcome bonuses)
 */
export async function getLoyaltySettings(): Promise<VenueLoyaltySettingsPublic> {
  const venueSlug = coreRuntime().getVenueSlug();
  return api.get<VenueLoyaltySettingsPublic>(`/venues/${venueSlug}/loyalty-settings`);
}
